<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="プリセット名"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'name') }"
					:message="errors.name">
					<b-input type="text" v-model="name" />
				</b-field>

				<b-field label="チーム" class="mt-30" custom-class="require" horizontal>
					<div class="team-select-wrap">
						<div v-for="row in teams" :key="row.id">
							<div class="mb-10">
								<b-checkbox v-model="presetTeams"
									:native-value="row.id">
									{{ row.name }}
								</b-checkbox>
							</div>
						</div>
					</div>
				</b-field>

				<b-field label="" horizontal>
					<div v-show="$utils.hasError(errors, 'presetTeams')" style="color: #ff3860;font-size: 0.75rem;">{{ errors.presetTeams }}</div>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">{{ !id ? '登録' : '更新' }}</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.team-select-wrap {
	height: 410px;
	overflow: scroll;
	border: 1px solid #eee;
	padding: 10px;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import { Chrome } from 'vue-color'

export default {
	name: 'PresetEdit',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		Chrome,
	},
	data () {
		return {
			id: '',
			name: '',
			presetTeams: [],
			teams: [],
			errors: {
				name: '',
				presetTeams: '',
			},
			isLoading: false,
		}
	},
	computed: {
		titleStack () {
			return [
				'プリセット登録',
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
			};

			let pt = '';
			if (this.presetTeams.length > 0) pt = this.presetTeams;
			data.preset_teams = pt;

			this.$utils.log(data);

			try {
				let ep = 'presets';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
				this.$router.push({ name: 'preset' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.presetId ? '/' + this.$route.params.presetId: '';
			let ep = 'presets/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.presetTeams = res.data.preset_teams;
				this.teams = res.data.teams;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
